// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jumbo-cta .colorful-box{border-radius:20px;background:url(\"https://storage.googleapis.com/lumen5-site-images/website-assets/cta-bg.png\");background-size:cover}.jumbo-cta .btn-white:hover{color:#5645f5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
